<template>
  <v-app class="survey-container">
    <NavBarHome></NavBarHome>
    <!-- Main Contents -->
    <v-layout wrap class="page-body bg-light-blue">
      <v-flex xs6 class="flex-vert-ctr" justify-center>
        <div class="sign-in-box">
          <v-form v-model="isFormValid" ref="form">
            <v-layout wrap>
              <v-flex xs12>
                <h1>Change your password</h1>
              </v-flex>
              <v-flex class="logo-center" xs2>
                <img src="../assets/NSF_Logo_flat.png" alt="NSF logo" width="100px" />
              </v-flex>
              <v-flex xs5>
                <div v-if="error" class="error-text">The current password is not correct.</div>
                <v-layout column align-center>
                  <!-- <v-text-field solo class="log-in-fields" placeholder="Username" v-model="username" v-on:keyup.enter="login" /> -->
                  <v-text-field
                    solo
                    class="log-in-fields"
                    placeholder="Old Password"
                    v-model="oldPassword"
                    :type="'password'"
                  />
                  <v-text-field
                    solo
                    class="log-in-fields"
                    placeholder="New Password"
                    v-model="newPassword"
                    :rules="rules"
                    :type="'password'"
                  />
                  <v-text-field
                    solo
                    class="log-in-fields"
                    placeholder="Confirm Password"
                    v-model="confirmPassword"
                    :type="'password'"
                    :rules="[passwordConfirmationRule]"
                    v-on:keyup.enter="changePassword"
                  />
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-btn
                      normal
                      :loading="isLoading"
                      :disabled="!isFormValid || !confirmPassword"
                      class="blue-button"
                      @click="changePassword"
                    >Submit</v-btn>
                    <v-btn normal :loading="isLoading" class="blue-button" @click="landing">Cancel</v-btn>
                    <br/>&nbsp;<span style="color:blue;">{{pwdMessage}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs5 pl-2>
                <div class="infoBox">
                  <h3 class="mt-1">Password rules</h3>
                  <ul class="mt-3">
                    <li>A minimum of 8 characters</li>
                    <li>Must contain at least one uppercase letter, one lowercase letter, and one number</li>
                    <li>Use of special characters is recommended (e.g., $#!^%, etc.)</li>
                  </ul>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-flex>
    </v-layout>
    <Footer></Footer>
  </v-app>
</template>

<script>
import { authService } from "@/services/authService.js";
import router from "@/router";
import { authTokenService } from "@/services/authTokenService.js";
export default {
  name: "changepassword",
  data () {
    return {
      username: "",
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      displayPassword: false,
      isLoading: false,
      error: false,
      isFormValid: false,
      pwdMessage: null,
      rules: [
        v =>
          (v &&
            v.length >= 8 &&
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(v)) ||
          "Your new password must be at least 8 characters and contain at least one uppercase letter, one lowercase letter, and one number."
      ]
    };
  },
  computed: {
    passwordConfirmationRule () {
      return () =>
        this.newPassword === this.confirmPassword ||
        "The new passwords do not match.";
    }
  },
  methods: {
    login () {
      this.$data.isLoading = true;
      let me = this;
      authService
        .login(
          this.$data.userName,
          this.$data.oldPassword,
          this.$data.newPassword,
          this.$data.confirmPassword
        )
        .then(function(response) {
          me.$data.isLoading = false;
          // Redirect to home. Look at how to redirect to nextUrl?
          router.push({ name: "landing" });
        })
        .catch(function(response) {
          console.log("Test handle error in component");
          me.$data.isLoading = false;
        });
    },
    changePassword () {
      this.$data.isLoading = true;
      let me = this;
      me.pwdMessage = "Processing please wait..";
      const claims = authTokenService.getClaims();
      authService
        .changePassword(
          claims.userName,
          this.$data.oldPassword,
          this.$data.newPassword,
          this.$data.confirmPassword
        )
        .then(function(response) {
          me.$data.isLoading = false;
          me.pwdMessage = "PASSWORD SUCCESSFULLY CHANGED";
        })
        .catch(function(response) {
          console.log("Test handle error in component");
          me.$data.error = true;
          me.$data.isLoading = false;
          me.pwdMessage = "Error occured";
        });
    },
    landing () {
      router.push({ name: "landing" });
    }
  }
};
</script>

<style scoped>
.left {
  text-align: left;
  margin-left: 2%;
}

.sign-in-box h1 {
  margin-bottom: 30px;
}

.infoBox {
  border: 1px solid #a4b3ce;
  padding: 15px 10px 5px 10px;
  margin: 5px;
  border-radius: 5px;
  background-color: #f2f6fd;
}

ul {
  text-align: left;
}

li {
  font-size: 10pt;
  margin-bottom: 5px;
}

.contents-pane {
  margin-top: 5%;
  margin-bottom: 5%;
  margin-left: -5%;
  background-color: #f2f7fa;
  padding: 3%;
  text-align: left;
  border-style: solid;
  border-width: 0px 0px 0px 15px;
  border-color: #365f8d;
  font-size: 11pt;
  color: black;
}

.logo-center {
  text-align: center;
}
.log-in-fields {
  margin-bottom: -15px;
  width: 275px;
}
.log-in-fields >>> input {
  text-align: left;
}
.indent {
  margin-left: 3%;
}

</style>
